// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/cg-controllability.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/cg-controllability/cg-controllability.js';

mount([g0]);
